import styled from 'styled-components';

const ProjectCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 238px;
  padding: 10px 15px 15px 15px;
`;

const ProjectCardHeader = styled.div`
  display: flex;
  align-items: center;
  min-height: 40px;
  gap: 4px;
`;

const ProjectCardHeaderRight = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
`;

const ProjectCardFavoriteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
  border-radius: 4px;

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme['color.purpleLight']};
    outline-offset: 2px;
  }
`;

const ProjectCardDate = styled.div`
  flex: 1;
  min-width: 0;
  padding-left: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${(props) => props.theme['color.text.light']};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
`;

const ProjectCardContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 20px;
  height: 100%;
  color: ${(props) => props.theme['color.text.title']};
  justify-content: flex-start;
  align-items: center;
`;

const ProjectCardTitle = styled.div`
  line-height: 34px;
  text-align: center;
  margin-top: 25px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ProjectAvatarStackWrapper = styled.div`
  display: flex;
  margin-top: 5px;

  & > div {
    margin-right: 0;
  }
`;

export {
  ProjectCardContainer,
  ProjectCardHeader,
  ProjectCardHeaderRight,
  ProjectCardFavoriteButton,
  ProjectCardTitle,
  ProjectCardContent,
  ProjectCardDate,
  ProjectAvatarStackWrapper,
};
